import * as React from 'react';
import {
    Datagrid,
    List,
    TextField,
    NumberField,
    DateField,
} from 'react-admin';
import BadgeRelated from '../components/BadgeRelated';
import { Box, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import { dateLocales, defaultDateOptions } from '../utils/formatters';
import financings from '../financings';

const useStyles = makeStyles(theme => ({
    root: {
        // width: '50%',
        // margin: '0 auto',
        maxWidth: '500px',
    },
    table: {
        width: '100%'
    },
    name: { fontWeight: 'bold' },
}))
const PlatformList = (props: any) => {
    const classes = useStyles()

    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('xs')
    );

    return <MyList
        className={classes.root}
        {...props}>
        <Datagrid
            size="medium"
            className={classes.table}
        // rowStyle={rowStyle}
        >
            <NumberField source="id" label="resources.common.fields.id" />
            {!isXSmall && <DateField source="created_at" label="resources.common.fields.created_at" locales={dateLocales} options={defaultDateOptions}/>}
            {!isXSmall && <DateField source="updated_at" label="resources.common.fields.updated_at" locales={dateLocales} options={defaultDateOptions}/>}
            <TextField source="name" className={classes.name} />
            {/* <TextField source="data" /> */}
            <BadgeRelated
                icon={financings.icon}
                source="Financings_aggregate.aggregate.count"
                reference="Financing"
                target="platform_id"
                label="resources.Platform.fields.financings"
                getColor
            />
        </Datagrid>
    </MyList>
};

const MyList = (props: any) => (
    <List
        {...props}
        component={Box}
        pagination={null}
        bulkActionButtons={false}
        exporter={false}
        actions={false}
        sort={{ field: 'id', order: 'ASC' }}
    >   
        {props.children}
    </List>
);

export default PlatformList;